import React from 'react';
import Link from 'next/link';
import { ButtonTags } from '@/constants/ButtonTags';
import { Eyebrow } from '../Eyebrow/Eybrow';
import { ContactUsAvatarGroup } from './ContactUsAvatarGroup';
import styles from './TrustpilotContactUs.module.scss';
import { Button, IButton } from '../../Button';
import { Mode } from '../../Mode';

type SectionContent = {
  heading: React.ReactNode;
  subheading: React.ReactNode;
};

type ContactUsButtonProps = {
  buttonText: string;
  onButtonClick?: IButton['onClick'];
  buttonHref?: IButton['href'];
};

export interface TrustpilotContactUsProps {
  trustpilot: SectionContent;
  contactUs: SectionContent & ContactUsButtonProps;
}

export const TrustpilotContactUs = ({ trustpilot, contactUs }: TrustpilotContactUsProps) => {
  const ref = React.useRef(null);

  /* Load trustpilot once it is available from the ref */
  React.useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div className={styles.backgroundContainer}>
      <div className={styles.backgroundContainerAngle} />
      <section className={styles.trustpilotContainer}>
        <h2>{trustpilot.heading}</h2>
        <p>{trustpilot.subheading}</p>
        <div
          ref={ref}
          className={`trustpilot-widget ${styles.trustpilotWidget}`}
          data-locale="en-GB"
          data-template-id="54ad5defc6454f065c28af8b"
          data-businessunit-id="5c08b592390696000193c25d"
          data-style-height="240px"
          data-style-width="100%"
          data-theme="dark"
          data-stars="4,5"
          data-review-languages="en"
        >
          <div className={styles.trustpilotFallback}>
            <p>
              Sorry, there’s a problem loading Athena’s reviews. Try refreshing the page, or check them out{' '}
              <Link href="https://au.trustpilot.com/review/athena.com.au" target="_blank">
                here
              </Link>
              .
            </p>
            <img src="/next-assets/images/cohort/trustpilot-logo-widget-fallback.svg" alt="Trustpilot icon" />
          </div>
        </div>
      </section>
      <section className={styles.contactUsContainer}>
        <ContactUsAvatarGroup />
        <div className={styles.eyebrow}>
          <Eyebrow>LOCAL KNOWLEDGE</Eyebrow>
        </div>
        <h2>{contactUs.heading}</h2>
        <p>{contactUs.subheading}</p>
        <Button
          ButtonTag={ButtonTags.BUTTON}
          mode={Mode.LIGHT}
          icon="r"
          type="outline"
          href={contactUs.buttonHref}
          onClick={contactUs.onButtonClick}
        >
          {contactUs.buttonText}
        </Button>
      </section>
    </div>
  );
};
